import app from "../Main/base";
import axios from "axios";

import firebase from "firebase";
import * as geofire from "geofire-common";
import StaticTime from "../Models/StaticTime";

export const getDate = (dateSec) => {
  let dateInMillis = dateSec.seconds * 1000;
  // console.log(
  //   "Date ========================================================>",
  //   dateInMillis
  // );
  var date =
    new Date(dateInMillis).toDateString() +
    " at " +
    new Date(dateInMillis).toLocaleTimeString();

  return date;
};

// export const getUserById = async (userId) => {
//   return new Promise((resolve, reject) => {
//     app
//       .firestore()
//       .collection(`chatUsers`)
//       .doc(userId)
//       .get()
//       .then((doc) => {
//         if (doc.exists) {
//           // console.log("Document data:", doc.data());
//           resolve(doc.data());
//         } else {
//           // doc.data() will be undefined in this case
//           // console.log("No such document!");
//         }
//       })
//       .catch((error) => {
//         // console.log("Error getting document:", error);
//         reject(error);
//       });
//   });
// };

export const getUserNameById = async (userId) => {
  return new Promise((resolve, reject) => {
    let name = "";
    app
      .firestore()
      .collection(`chatUsers`)
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          name = doc.data().firstName;
          resolve(doc.data().firstName + " " + doc.data().lastName);
        } else {
          // doc.data() will be undefined in this case
          // console.log("No such document!");
        }
      })
      .catch((error) => {
        // console.log("Error getting document:", error);
        reject(error);
      });
    return name;
  });
};

export const getUserNameById2 = (userId) => {
  let name = "";
  app
    .firestore()
    .collection(`chatUsers`)
    .doc(userId)
    .get()
    .then((doc) => {
      if (doc.exists) {
        // console.log("Document data:", doc.data());
        name = doc.data().firstName;
        // resolve(doc.data().firstName + " " + doc.data().lastName);
      } else {
        // doc.data() will be undefined in this case
        // console.log("No such document!");
      }
    })
    .catch((error) => {
      // console.log("Error getting document:", error);
      // reject(error);
    });
  return name;
};

export const getUserAvatarById = async (userId) => {
  return new Promise((resolve, reject) => {
    let avatar = "";
    app
      .firestore()
      .collection(`chatUsers`)
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          avatar = doc.data().avatar;
          resolve(doc.data().avatar);
        } else {
          // doc.data() will be undefined in this case
          // console.log("No such document!");
        }
      })
      .catch((error) => {
        // console.log("Error getting document:", error);
        reject(error);
      });
    return avatar;
  });
};

export const putStorageItem = async (item) => {
  // the return value will be a Promise
  // console.log(item);
  return app
    .storage()
    .ref(item.path)
    .put(item.image)
    .then((snapshot) => {
      // console.log("One success:", item);
    })
    .catch((error) => {
      // console.log("One failed:", item, error.message);
    });
};

export const handleUpload = async (item) => {
  return new Promise((resolve, reject) => {
    const uploadTask = app.storage().ref(item.path).put(item.image);

    uploadTask.on(
      "state_change",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log("Upload is " + progress + "% done");
      },
      (error) => {
        // console.log(error);
        reject(error);
      },
      async () => {
        let imgURL = await uploadTask.snapshot.ref.getDownloadURL();
        // console.log("uploaded image: " + imgURL.toString());
        resolve(imgURL);
      }
    );
  });
};

export const iAmOwner = async (owner_id) => {
  return owner_id === app.auth().currentUser.uid;
};

export const updatePlane = async (plane, plane_id) => {
  return new Promise((resolve, reject) => {
    // .doc() will make auto-generated ID,
    app
      .firestore()
      .collection("plane")
      .doc(plane_id)
      .set(plane)
      .then(() => {
        // console.log(" Plane  ==>> Document successfully written!");
        resolve("Plane successfully written!");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
        reject(error);
      });
  });
};

export const createPlane = async (plane, pid) => {
  return new Promise((resolve, reject) => {
    plane.owner_id = app.auth().currentUser.uid;
    plane.form_one_finished = true;
    plane.display_images = [
      `/planes/${pid}/display_images/image_main`,

      `/planes/${pid}/display_images/image_slot_1`,
      `/planes/${pid}/display_images/image_slot_2`,
      `/planes/${pid}/display_images/image_slot_3`,

      `/planes/${pid}/display_images/image_slot_4`,
      `/planes/${pid}/display_images/image_slot_5`,
      `/planes/${pid}/display_images/image_slot_6`,

      `/planes/${pid}/display_images/image_slot_7`,
      `/planes/${pid}/display_images/image_slot_8`,
      `/planes/${pid}/display_images/image_slot_9`,
    ];

    plane.inspection_images = [
      {
        name: "altimeter",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/altimeter_image`,
      },
      {
        name: "elt",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/elt_image`,
      },
      {
        name: "one_hundred_hour_inspection",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/one_hundred_hour_inspection_image`,
      },
      {
        name: "vor_inspection",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/vor_inspection_image`,
      },
      {
        name: "transponder",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/transponder_image`,
      },
      {
        name: "airworthiness_certificate",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/airworthiness_certificate`,
      },
      {
        name: "operating_manuel",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/operating_manuel`,
      },
      {
        name: "registration_certificate",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/registration_certificate`,
      },
      {
        name: "weight_balance",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/weight_balance`,
      },
      {
        // Static/Pilot Inspection Picture
        name: "static_pilot_inspection",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/static_pilot_inspection`,
      },
      {
        // Operating Handbook
        name: "operating_handbook",
        date: new Date(0),
        image_path: `/planes/${pid}/inspection_images/operating_handbook`,
      },
    ];

    // console.log("send this plane, =>", plane);

    //timeout(25000); //for 25 sec delay
    app
      .firestore()
      .collection("plane")
      .doc(pid)
      .set(plane)
      .then(() => {
        // console.log(" Plane  ==>> Document successfully written!");
        resolve("Plane successfully written!");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
        reject(error);
      });
  });
};

export const hashFunc = async (lat, lng) => {
  console.log("lat:", lat, "lng", lng);
  var hash = await geofire.geohashForLocation([lat, lng]);
  console.log("Newark geohash: ", hash);
  return hash;
};

export const getDoc = async (db, collection, docId) => {
  console.log("collection path => ", collection, " /// docId => ", docId);
  try {
    const snapshot = await db.collection(collection).doc(docId).get();
    const { exists, id } = snapshot;

    if (!exists) {
      throw new Error(`Document ${id} not found.`);
    }

    const document = snapshot.data();

    if (!document) {
      throw new Error(`Data undefined for document ${id}.`);
    }
    console.log("document =>", document);
    return document;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (db, collection, docId) => {
  console.log("collection path => ", collection, " /// docId => ", docId);
  try {
    const snapshot = await db.collection(collection).doc(docId).get();
    const { exists, id } = snapshot;

    if (!exists) {
      throw new Error(`Document ${id} not found.`);
    }

    const document = snapshot.data();

    if (!document) {
      throw new Error(`Data undefined for document ${id}.`);
    }

    return `${document.firstName} ${document.lastName}`;
  } catch (error) {
    throw error;
  }
};

// ------------------// ------------------// ------------------// ------------------// ------------------
//  MapBox Functions
// ------------------// ------------------// ------------------// ------------------// ------------------

export const getLatLngGeoHash = async (data) => {
  return new Promise((resolve, reject) => {
    let location = data.base_plane_location;
    const address = location.replaceAll(" ", "%20");
    //Newark Liberty International Airport
    let geo_point_var = [0, 0];
    let lat = 0;
    let lng = 0;
    let geohash_var = "nohash";
    axios
      .get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?country=US&types=address&access_token=pk.eyJ1IjoiNDRuYXNoIiwiYSI6ImNrbnFvMjY1dDBjMGQydnFvNjNtZ2p2am8ifQ.G61N5C3tvokOBxfamQCC4g`
      )
      .then((res) => {
        console.log(location, " => ", res);
        //  geohash = geofire.geohashForLocation([41.707425, -86.89924]);
        geo_point_var = res.data.features[0].center;
        console.log(location, " coord => ", res.data.features[0].center);
        return geo_point_var;
      })
      .then((res) => {
        try {
          //geohash_var = await hashFunc(res[1], res[0]);

          lat = res[1];
          lng = res[0];
          geohash_var = geofire.geohashForLocation([lat, lng]);
          //return [lat, lng, geohash_var];
          resolve([lat, lng, geohash_var]);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
  });
  //return [lat, lng, geohash_var];
};

export const getCoordinates = async () => {
  let addressOne = "65 Ann Street Michigan City, IN 46360";
  let newAddress = addressOne.replaceAll(" ", "%20");
  console.log("current address", newAddress);
  await axios
    .get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${newAddress}.json?country=US&types=address&access_token=pk.eyJ1IjoiNDRuYXNoIiwiYSI6ImNrbnFvMjY1dDBjMGQydnFvNjNtZ2p2am8ifQ.G61N5C3tvokOBxfamQCC4g`
    )
    .then((res) => {
      console.log("data from 65 Ann Street Michigan City, IN 46360 => ", res);
    });
};

export const reload = () => {
  setTimeout(function () {
    window.location.reload();
  }, 3000);
};

export function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}

export const getImageUrl = async (storage, path) => {
  try {
    const url = await storage.ref(path).getDownloadURL();

    return url;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//
export const updateDoc = async (db, collection, docId, newObject) => {
  try {
    const snapshot = await db
      .collection(collection)
      .doc(docId)
      .set(
        {
          ...newObject,
        },
        { merge: true }
      );
    const { exists, id } = snapshot;

    if (!exists) {
      throw new Error(`Document ${id} not found.`);
    }

    const document = snapshot.data();

    if (!document) {
      throw new Error(`Data undefined for document ${id}.`);
    }

    return document;
  } catch (error) {
    throw error;
  }
};

export const updateDoc2 = async (db, collection, docId, newObject) => {
  try {
    const snapshot = await db
      .collection(collection)
      .doc(docId)
      .set(
        {
          ...newObject,
        },
        { merge: true }
      )
      .then(() => {
        console.log(`Document ${docId} successfully updated!`);
        return `Document ${docId} successfully updated!`;
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error(`Error updating ${docId}  document: `, error);
        return error;
      });

    // const { exists, id } = snapshot;

    // if (!exists) {
    //   throw new Error(`Document ${id} not found.`);
    // }

    // const document = snapshot.data();

    // if (!document) {
    //   throw new Error(`Data undefined for document ${id}.`);
    // }

    // return document;
  } catch (error) {
    throw error;
  }
};

export const convertDate = (date) => {
  // whatever formatting you want to do can be done here
  var d = date.toString();
  return d.substr(0, 21);
};

export const toDateTime = (secs) => {
  // firebase has UTC-4 timestamp so this works it out
  var t = new Date(Date.UTC(1970, 0, 1)); // Epoch
  t.setUTCSeconds(secs);
  return t;
};

export const distance = (lat1, lon1, lat2, lon2, unit) => {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }
};
//
//
// //
//
// //
//
// //
//
// //
//
// //
//
// //
//
// //
//
//
//      List Functions for Calendar
export const createStaticTimeList = async (plane) => {
  let timeList = [];

  for (let index in plane.static_time) {
    //staticTimesList.push(
    timeList.push(
      new StaticTime(
        plane.static_time[index].time_id,
        toDateTime(plane.static_time[index].start.seconds),
        toDateTime(plane.static_time[index].end.seconds),
        plane.static_time[index].flat_rate,
        plane.static_time[index].rate_per_hour,
        plane.static_time[index].pilot_id,
        plane.static_time[index].title,
        plane.static_time[index].color
      )
    );
  }

  return timeList;
};

export const createRecurringTimesList = async (plane, monthsAhead) => {
  let timeList = [];
  for (let dayIndex in plane.recurring_time) {
    let dayOfWeek = plane.recurring_time[dayIndex];
    let title = dayOfWeek.title;

    console.log("dayIndex = ", dayIndex);
    console.log("dayOfWeek = ", dayOfWeek);
    console.log("title = ", title);
    for (let timeIndex in dayOfWeek.times) {
      let timeObject = dayOfWeek.times[timeIndex];
      let startVar = toDateTime(dayOfWeek.times[timeIndex].start.seconds);
      let endVar = toDateTime(dayOfWeek.times[timeIndex].end.seconds);
      const monthVar = startVar.getMonth();
      const hours = startVar.getHours(); // 13
      const minutes = startVar.getMinutes(); // 5
      const hoursE = endVar.getHours(); // 13
      const minutesE = endVar.getMinutes(); // 5
      // console.log("startVar time = ", hours, ":", minutes);
      // console.log("endVar time = ", hoursE, ":", minutesE);
      // console.log("title = ", title);

      var d = new Date();
      let datesList = [];
      // two months ahead
      for (let monthsplus = 0; monthsplus <= monthsAhead; monthsplus++) {
        switch (title) {
          case "SUN":
            datesList = getDaysOfMonth(
              d,
              0,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "MON":
            datesList = getDaysOfMonth(
              d,
              1,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "TUE":
            datesList = getDaysOfMonth(
              d,
              2,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "WED":
            datesList = getDaysOfMonth(
              d,
              3,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "THU":
            datesList = getDaysOfMonth(
              d,
              4,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "FRI":
            datesList = getDaysOfMonth(
              d,
              5,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
          case "SAT":
            datesList = getDaysOfMonth(
              d,
              6,
              monthsplus,
              dayOfWeek,
              timeObject,
              startVar,
              endVar
            );
            timeList = timeList.concat(datesList);
            console.log("datesList = ", datesList);
            break;
        }
      }
    }
    // }
  }

  return timeList;
};

function setDateTime(myDate, hour, min, sec) {
  // Set hours
  myDate.setHours(hour);

  // Then set minutes
  myDate.setMinutes(min);

  // Then set seconds
  myDate.setSeconds(sec);
  return myDate;
}

function getDaysOfMonth(
  d,
  dayOfweek,
  monthsplus,
  dayOfWeek,
  timeObject,
  start,
  end
) {
  //var d = new Date();
  console.log(
    "day =>",
    d,
    " dayOfweek => ",
    dayOfweek,
    " month number => ",
    d.getMonth() + monthsplus
  );
  var getTot = daysInMonth(d.getMonth() + monthsplus, d.getFullYear()); //Get total days in a month
  //var sat = new Array(); //Declaring array for inserting Saturdays
  //var sun = new Array(); //Declaring array for inserting Sundays

  let dayOfweekList = [];
  console.log("startVar time = ", start.getHours(), ":", start.getMinutes());
  console.log("endVar time = ", end.getHours(), ":", end.getMinutes());
  for (var i = 1; i <= getTot; i++) {
    //looping through days in month
    var newDate = new Date(d.getFullYear(), d.getMonth() + monthsplus, i);
    var lastDate = new Date(d.getFullYear(), d.getMonth() + monthsplus, i);
    if (newDate.getDay() == dayOfweek) {
      //if Sunday
      let startDate = setDateTime(
        newDate,
        start.getHours(),
        start.getMinutes(),
        start.getSeconds()
      );

      let endDate = setDateTime(
        lastDate,
        end.getHours(),
        end.getMinutes(),
        end.getSeconds()
      );

      console.log("startDate time = ", startDate);
      console.log("endDate time = ", endDate);
      let time = new StaticTime(
        timeObject.time_id,
        startDate,
        endDate,
        timeObject.flat_rate,
        timeObject.rate_per_hour,
        timeObject.pilot_id,
        dayOfWeek.title,
        timeObject.color
      );
      dayOfweekList.push(time);
    }
    // if (newDate.getDay() == 6) {
    //   //if Saturday
    //   sat.push(newDate);
    // }
  }
  // console.log("saturday => ", sat);
  // console.log("sunday => ", sun);
  console.log("day => ", dayOfweek);
  console.log("dayOfweekList => ", dayOfweekList);
  return dayOfweekList;
}

function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
